import { adminRepositories } from "data/admin/repositories";
import { seedLegalDocuments } from "data/seedLegalDocuments";

export const legalDocumentsRepo = {
  list(params) {
    return adminRepositories.legalDocuments.list(params);
  },

  getById(id) {
    return adminRepositories.legalDocuments.getById(id);
  },

  create(item) {
    return adminRepositories.legalDocuments.create(item);
  },

  update(id, patch) {
    return adminRepositories.legalDocuments.update(id, patch);
  },

  remove(id) {
    return adminRepositories.legalDocuments.remove(id);
  },

  restore(id) {
    return adminRepositories.legalDocuments.restore(id);
  },

  /** Eksik varsayılan yasal metinleri seed’den ekler; mevcut kayıtları bozmaz. */
  seedMissingDefaults() {
    const existing = new Set(this.list({ includeDeleted: true }).map((item) => item.id || item.slug));
    let created = 0;
    for (const item of seedLegalDocuments) {
      const id = item.id || item.slug;
      if (!id || existing.has(id)) continue;
      this.create(item);
      created += 1;
    }
    return created;
  },
};
